<div class="container-fluid">
    <app-pagetitle title="Category" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row d-flex justify-content-between mb-2">
                        <a class="btn btn-success mb-2" (click)="openModal(content, '', 'Add')">
                            <i class="mdi mdi-plus mr-2"></i> Add Category
                        </a>
                        <div class="d-flex justify-content-between">

                            <div>
                                <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
                            </div>
                            <div class="col-md-3 d-flex justify-content-end">
                                <button class="btn btn-primary" title="Back" (click)="goBack()">
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive mt-3" *ngIf="categoryData.length > 0; else noData">
                        <table class="table table-striped table-bordered table-centered dt-responsive nowrap"
                            style="border-collapse: collapse; border-spacing: 0; width: 100%">
                            <thead class="thead-dark">
                                <tr>
                                    <th>Category</th>
                                    <th>Type</th>
                                    <th>Is Category</th>
                                    <th style="width: 120px">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let item of categoryData | filter: searchTerm | slice: pageSize | slice: 0: itemsPerPage; let i = index">
                                    <td>{{ item.categoryName }}</td>
                                    <td>{{ item.categoryType }}</td>
                                    <td>{{ item.isCategory ? 'Yes' : 'No' }}</td>
                                    <td>
                                        <!-- ✅ Added Edit button -->
                                        <a class="text-primary mr-2" title="Edit" style="cursor: pointer"
                                            (click)="openModal(content, item, 'Edit')">
                                            <i class="mdi mdi-pencil font-size-18"></i>
                                        </a>
                                        <a class="text-danger" title="Delete" style="cursor: pointer"
                                            (click)="openModalDelete(deletetemp, item)">
                                            <i class="mdi mdi-trash-can font-size-18"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="col-md-6" *ngIf="categoryData?.length > itemsPerPage">
                            <ngb-pagination class="pagination-rounded" [collectionSize]="categoryData?.length"
                                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true"
                                [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
                            </ngb-pagination>
                        </div>
                    </div>

                    <!-- No Data -->
                    <ng-template #noData>
                        <div class="card p-3">
                            <span><strong>{{ errmsg || 'No Category Found. Please Add Category' }}</strong></span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add/Edit Modal -->
<ng-template #content role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">{{ action }} Category</h5>
        <button type="button" class="close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body card-body">
        <div class="row">

            <div class="form-group col-md-6">
                <label>Category Name <span class="text-danger">*</span></label>
                <select class="form-control" [(ngModel)]="categoryName">
                    <option value="">-- Select Category Name --</option>
                    <option value="Downtime Interlock">Downtime Interlock</option>
                    <option value="Threshold Interlock">Threshold Interlock</option>
                </select>
                <small class="text-danger" *ngIf="submitted && !categoryName">Category name is required.</small>
            </div>

            <div class="form-group col-md-6">
                <label>Category Type <span class="text-danger">*</span></label>
                <select class="form-control" [(ngModel)]="categoryType">
                    <option value="">-- Select Category Type --</option>
                    <option *ngFor="let type of categoryTypes" [value]="type">{{ type }}</option>
                </select>
                <small class="text-danger" *ngIf="submitted && !categoryType">Category type is required.</small>
            </div>

        </div>

        <!-- ✅ Toggle button for isCategory -->
        <div class="form-group mt-3">
            <label class="d-block">Is Category</label>
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="isCategoryToggle" [(ngModel)]="isCategory" />
                <label class="custom-control-label" for="isCategoryToggle">
                    {{ isCategory ? 'Yes' : 'No' }}
                </label>
            </div>
        </div>

        <div class="mt-4">
            <button type="button" class="btn btn-primary round waves-effect" (click)="saveCategory()">
                {{ action }}
            </button>
            &nbsp;
            <button type="button" class="btn btn-secondary round waves-effect" (click)="modal('Cross click')">
                Cancel
            </button>
        </div>
    </div>
</ng-template>

<!-- Delete Modal -->
<ng-template #deletetemp role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Category</h5>
        <button type="button" class="close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body card-body">
        <p>Are you sure you want to delete this category?</p>
        <button type="button" class="btn btn-danger round waves-effect" (click)="delete(delCategoryId)">
            Delete
        </button>
        &nbsp;
        <button type="button" class="btn btn-info round waves-effect" (click)="modal('Cross click')">
            Cancel
        </button>
    </div>
</ng-template>